import React from 'react';
import { useSelector } from 'react-redux';
import Pagination from '../../components/shared/table/pagination/Pagination';
import {
  nextClientsPageAction,
  prevClientsPageAction,
  setClientsPageSizeAction,
} from '../../redux/actions/clientsActions';

const ClientsPagination = () => {
  const pageable = useSelector((state) => state.clients?.pageable);
  return (
    <Pagination
      pageable={pageable}
      onNextPageClickAction={nextClientsPageAction}
      onPrevPageClickAction={prevClientsPageAction}
      onPageSizeChangeAction={setClientsPageSizeAction}
    />
  );
};

export default ClientsPagination;
